import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import { extractErrorMessage } from "../../../api";
import {
    completeLearnerContentApi,
    fetchLearnerModulePlayerApi,
    startLearnerContentApi,
    startLearnerModuleApi,
    updateLearnerContentProgressApi,
} from "../../services/learnerModulesApi";
import {
    completeLearnerContentFail,
    completeLearnerContentSuccess,
    fetchModulePlayerFail,
    fetchModulePlayerSuccess,
    setModuleLearningLoading,
    startLearnerContentFail,
    startLearnerContentSuccess,
    startLearnerModuleFail,
    startLearnerModuleSuccess,
    updateLearnerContentProgressFail,
    updateLearnerContentProgressSuccess,
} from "../actions/moduleLearningActions";

export function* fetchModulePlayerSaga(action) {
    const { moduleId } = action.payload;
    yield put(setModuleLearningLoading(true));
    try {
        const response = yield call(fetchLearnerModulePlayerApi, moduleId);
        yield put(fetchModulePlayerSuccess(response.data));
    } catch (error) {
        yield put(fetchModulePlayerFail(extractErrorMessage(error, "Impossible de charger le player du module.")));
    } finally {
        yield put(setModuleLearningLoading(false));
    }
}

export function* startLearnerModuleSaga(action) {
    const { moduleId, payload } = action.payload;
    try {
        const response = yield call(startLearnerModuleApi, moduleId, payload);
        yield put(startLearnerModuleSuccess(response.data));
    } catch (error) {
        yield put(startLearnerModuleFail(extractErrorMessage(error, "Impossible de demarrer le module.")));
    }
}

export function* startLearnerContentSaga(action) {
    const { moduleId, contentId, payload } = action.payload;
    try {
        const response = yield call(startLearnerContentApi, moduleId, contentId, payload);
        yield put(startLearnerContentSuccess(response.data));
    } catch (error) {
        yield put(startLearnerContentFail(extractErrorMessage(error, "Impossible d'ouvrir ce contenu.")));
    }
}

export function* completeLearnerContentSaga(action) {
    const { moduleId, contentId, payload } = action.payload;
    try {
        const response = yield call(completeLearnerContentApi, moduleId, contentId, payload);
        yield put(completeLearnerContentSuccess(response.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Contenu marqué comme terminé.",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de terminer ce contenu.");
        yield put(completeLearnerContentFail(message));
        yield call([Swal, Swal.fire], { icon: "error", text: message });
    }
}

export function* updateLearnerContentProgressSaga(action) {
    const { moduleId, contentId, payload } = action.payload;
    try {
        const response = yield call(updateLearnerContentProgressApi, moduleId, contentId, payload);
        yield put(updateLearnerContentProgressSuccess(response.data));
    } catch (error) {
        const message = extractErrorMessage(error, "Impossible de sauvegarder la progression.");
        const offline = typeof navigator !== "undefined" && navigator.onLine === false;
        yield put(updateLearnerContentProgressFail({ message, offline, contentId }));
    }
}
